import { RouteObject } from 'react-router-dom';
import LegacyIFrame from '../pages/Legacy/LegacyIFrame';

export const memberLegacyPaths = [
  '/my_wsg.asp',
  '/wsglearninginstitute_growthplay.asp',
  '/wsglearninginstituteoverview.asp',
  '/wsg_mailbox.asp',
  '/myprofile',
  '/networkwire_2q2024.asp',
  '/wsg_practicemembers.asp',
  '/members-search.asp',
  '/wsg-introduction.asp',
  '/wsg_modifypers_new.asp',
  '/wsg_modifypers.asp',
  '/my_preferences.asp',
  '/wsg_practiceresources.asp',
  '/wsg_practiceforums.asp',
  '/preferred_contacts.asp'
];
const generateLegacyRoutes = (paths: string[]): RouteObject[] => {
  return paths.map(path => ({
    path,
    element: <LegacyIFrame />
  }));

};

export const MemberLegacyRoutes: RouteObject[] = generateLegacyRoutes(memberLegacyPaths); 